import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { REQUEST_STATUS_DATA_DISPLAY as StatusDisplay } from '../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData, comparePaths } from '../../../../utils/helpers.utils'
import { REQUEST_SUB_LINKS as RequestTable, ORDER_STATUS as OrderStatus, ROUTE_LINK_LOCATION } from '../../../../constants/external-constants';
import { RequestDetailModal, ConfirmationModal, RejectConfirmationModal } from "../../../common/modal/modal.component";
import Translation from "../../../common/translation/translation.component";
import { requestDetailsActions } from "../../../../store/external/request-reducer/request-details.reducer";
import { requestLogActions } from "../../../../store/external/request-reducer/request-log.reducer";
import { csatActions } from "../../../../store/external/csat-survey-reducer/csat-survey.reducer";

class RequestDetailDisplay extends Component {
    constructor(props) {
        super();
        this.RequestDetailModal = React.createRef();
        this.ConfirmationModal = React.createRef();
        this.RejectConfirmationModal = React.createRef();
        this.handleApprovalClick = this.handleApprovalClick.bind(this);
    }

    loadDetailDependencies = async () => {
        const {
            fetchRequestDetails,
            fetchRequestProgress,
            fetchOrderComments,
            fetchOwnerApproverDetails,
            fetchWorkFlowApproverDetails,
            selectedItem,
            isApprovedOrRejected,
            isShowSurvey
        } = this.props;

        await fetchRequestDetails();
        fetchWorkFlowApproverDetails();
        fetchOwnerApproverDetails();
        fetchRequestProgress();
        fetchOrderComments();
        isApprovedOrRejected(selectedItem);
        isShowSurvey(selectedItem, false);
    }

    componentDidMount() {
        const { selectedItem } = this.props;
        this.showModal(selectedItem);
        this.loadDetailDependencies();
    }

    componentDidUpdate(prevProps) {
        const prevOrderId = prevProps.match?.params?.id;
        const currentOrderId = this.props.match?.params?.id;

        if (prevOrderId !== currentOrderId) {
            this.loadDetailDependencies();
        }
    }

    showModal = (obj) => {
        this.RequestDetailModal.current.handleShow();
    };

    resetUrl = () => {
        this.props.history.goBack();
    }

    handleApprovalClick = async e => {
        e.preventDefault();
        const { handleApprovalSubmission
            , fetchRequestDetails
            , fetchRequestProgress
            , fetchOrderComments
            , fetchOwnerApproverDetails
            , fetchRequestLogItems } = this.props;

        var isSuccess = await handleApprovalSubmission();
        if (isSuccess) {
            fetchOwnerApproverDetails();
            fetchRequestDetails();
            fetchRequestProgress();
            fetchOrderComments();
            fetchRequestLogItems();
        }
    };

    showConfirmationModal = e => {
        this.ConfirmationModal.current.handleShow();
    };

    showRejectConfirmationModal = e => {
        this.RejectConfirmationModal.current.handleShow();
    };

    handleCancellationOrder = async e => {
        e.preventDefault();

        this.ConfirmationModal.current.handleClose();

        const { handleCancelSubmission, item
            , fetchRequestLogItems
            , fetchRequestProgress, fetchOrderComments, fetchRequestDetails, activeRequestTable
        } = this.props;
        var isSuccess = await handleCancelSubmission(item);
        if (isSuccess) {
            fetchRequestDetails();
            fetchRequestProgress(false);
            fetchOrderComments();
            fetchRequestLogItems(0, activeRequestTable);
        }

    };

    handleRejectionOrder = async e => {
        e.preventDefault();

        this.RejectConfirmationModal.current.handleClose();

        const { handleRejectionCommentSubmission, selectedItem
            , fetchRequestLogItems
            , fetchRequestProgress, fetchOrderComments, fetchRequestDetails
        } = this.props;
        var isSuccess = await handleRejectionCommentSubmission(selectedItem, this.RejectConfirmationModal.current.state.rejectReason);
        if (isSuccess) {
            fetchRequestDetails();
            fetchRequestProgress(false);
            fetchOrderComments();
            fetchRequestLogItems(0, RequestTable.orderRequest.id);
        }

    };

    canCancelOrder(orderStatusId, isOwner, isRequestor) {

        var canCancel = true;
        const path = comparePaths(this.props.history.location.pathname, ROUTE_LINK_LOCATION.orderDetailsRouteLink) || comparePaths(this.props.history.location.pathname, ROUTE_LINK_LOCATION.inventoryOrderHistoryLink);

        if (!(isOwner || isRequestor) || orderStatusId === OrderStatus.completed || orderStatusId === OrderStatus.progress_awaiting_submission || orderStatusId === OrderStatus.progress || orderStatusId === OrderStatus.canceled || orderStatusId === OrderStatus.rejected || orderStatusId === OrderStatus.approved || path) {
            canCancel = false;
        }

        return canCancel;
    };

    canHandleRequest(orderStatusId, costCode) {
        const { WireLineApprover } = this.props.requestData;

        var canHandleRequest = true;
        var user = getUserData();
        const path = comparePaths(this.props.history.location.pathname, ROUTE_LINK_LOCATION.orderDetailsRouteLink) || comparePaths(this.props.history.location.pathname, ROUTE_LINK_LOCATION.inventoryOrderHistoryLink);
        if (WireLineApprover) {
            if (!(user.employeeID == WireLineApprover?.EmployeeId) || orderStatusId === OrderStatus.completed || orderStatusId === OrderStatus.canceled || orderStatusId === OrderStatus.rejected || orderStatusId === OrderStatus.approved || orderStatusId === OrderStatus.progress || orderStatusId === OrderStatus.progress_awaiting_submission || path) {
                canHandleRequest = false;
            }

            return canHandleRequest;

        }
        else if (!(user.employeeID == this.props.approverWorkFlowData?.EmployeeId) || orderStatusId === OrderStatus.completed || orderStatusId === OrderStatus.canceled || orderStatusId === OrderStatus.rejected || orderStatusId === OrderStatus.approved || orderStatusId === OrderStatus.progress || orderStatusId === OrderStatus.progress_awaiting_submission || path) {
            canHandleRequest = false;
        }

        return canHandleRequest;
    };

    render() {
        const { requestData, currentOrderStatusId, requestMilestones, requestActivities, requestComments, isLoaded, selectedItem, isQuotation, approverData, approverWorkFlowData, isApproverLoaded
            , data
            //decision actions
            , handleApprovalSubmission
            , handleRejectionClick
            , handleCancelRejectionClick
            , showRejectionCommentBox
            , showDecisionButtons
        } = this.props;

        return (
            <div>
                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={<Translation translationKey="modal_cancel_title" />}
                    messageBody={<Translation translationKey="modal_cancel_content" />}
                    confirmAction={this.handleCancellationOrder}
                    closeLabel={<Translation translationKey="no_button" />}
                    confirmLabel={<Translation translationKey="yes_button" />}
                />
                <RejectConfirmationModal
                    ref={this.RejectConfirmationModal}
                    title={<Translation translationKey="request_rejected_modal_title" />}
                    messageBody={<Translation translationKey="request_rejected_modal_content" />}
                    confirmAction={this.handleRejectionOrder}
                    closeLabel={<Translation translationKey="modal_cancel_cancel_button" />}
                    confirmLabel={<Translation translationKey="yes_button" />}
                />
                <RequestDetailModal
                    history={this.props.history}
                    hasCloseAction={true}
                    id={"modal-order-details-" /*+ RequestTable.orderRequest.id*/}
                    ref={this.RequestDetailModal}
                    title={isQuotation ? selectedItem.RequestType : requestData.Order != undefined ? requestData?.Order?.RequestType?.RequestType : selectedItem.RequestType}
                    closeAction={this.resetUrl}
                    //data props
                    status={selectedItem.Status}
                    statusData={StatusDisplay}
                    data={requestData}
                    approverData={approverData}
                    approverWorkFlowData={approverWorkFlowData}
                    activities={requestActivities}
                    comments={requestComments}
                    milestone={requestMilestones}
                    selectedItem={selectedItem}
                    orderStatusId={currentOrderStatusId || requestData?.Order?.OrderStatusId || selectedItem.OrderStatusId || 0}
                    //bool props
                    isLoaded={isLoaded}
                    isOtherRequest={selectedItem.IsOtherRequest}
                    isQuotationRequest={isQuotation}
                    isApproverLoaded={isApproverLoaded}
                    canCancelOrder={this.canCancelOrder(selectedItem.OrderStatusId, selectedItem.IsOwner, selectedItem.IsRequestor)}
                    canHandleRequest={this.canHandleRequest(selectedItem.OrderStatusId, approverData.CostCodeAuthorizer)}
                    //decision actions
                    handleApprovalClick={this.handleApprovalClick}
                    showRejectionCommentBox={showRejectionCommentBox}
                    handleRejectionClick={handleRejectionClick}
                    handleCancelRejectionClick={handleCancelRejectionClick}
                    showConfirmationModal={this.showConfirmationModal}
                    showRejectConfirmationModal={this.showRejectConfirmationModal}
                    showDecisionButtons={showDecisionButtons}
                />
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestDetail, requestLog, csatSurveyRequest } = state;
        return {
            ...requestDetail
            , ...requestLog
            , csatSurveyRequest
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestDetailsActions, requestLogActions, csatActions),
            dispatch
        )
)(RequestDetailDisplay);
